import api from "@api";
import { IUserRelationships, IUser, IApiUser } from "./users";

const BASE_PATH = "/user";

export const getCurrentUser = <
  I extends (keyof IUserRelationships)[],
  F extends (keyof IApiUser)[]
>(options: {
  includes?: I;
  fields?: F;
}) => {
  return api.get<{ includes?: I; fields?: F }, IUser<I, F>>(BASE_PATH, options);
};
